import createGetFormInitialValues from './selectors/getFormInitialValues';
import plain from './structure/plain';

export default createGetFormInitialValues(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/getFormInitialValues.js
// module id = 2050
// module chunks = 0